import React, { useState, useRef, useEffect } from "react";
import "./tooltip.css";

/*
    hAnchor (string) "center", "left", "right"   the horizontal alignment of the tooltip
*/

const Tooltip = ({
  tooltipChildren,
  hAnchor = "center",
  className = "",
  children
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  useEffect(() => {
    if (tooltipRef.current) {
      const tooltipHeight = tooltipRef.current.offsetHeight;
      tooltipRef.current.style.top = `calc(-0.2rem - ${tooltipHeight}px)`;
    }
  }, [showTooltip]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tooltip-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "trigger-element",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onFocus: handleMouseEnter,
    onBlur: handleMouseLeave,
    onClick: handleMouseEnter
  }, children), showTooltip && /*#__PURE__*/React.createElement("div", {
    ref: tooltipRef,
    className: `tooltip tooltip-${hAnchor} ${className}`
  }, tooltipChildren));
};
export { Tooltip };